import * as tools from '../Tools';
import * as routes from './Routes';
import * as components from '../Components';
import * as Hvd from '../Hvd/';

export default class LayerAction {
    private static _instance: LayerAction;
    protected layer: HTMLElement;
    protected layerBody: HTMLElement;
    protected layerClose: NodeListOf<HTMLElement>;
    protected layerPost: NodeListOf<HTMLElement>;
    protected actionButton: HTMLElement = null;

    public static get Instance() {
        return LayerAction._instance || new LayerAction();
    }

    constructor() {
        const _this = this;
        if (!LayerAction._instance) {
            LayerAction._instance = this;
            this.layer = document.querySelector('.rw-layer');
            if (!this.layer) {
                return;
            }
            this.layerBody = this.layer.querySelector('.rw-body');
            this.layerClose = this.layer.querySelectorAll('.action-cancel');
            this.layerPost = this.layer.querySelectorAll('.action-post');
            this.layerClose.forEach((el) => {
                el.addEventListener('click', (e) => {
                    _this.evLayerClose();
                });
            });
            this.layerPost.forEach((el) => {
                el.addEventListener('click', (e) => {
                    _this.evSaveData();
                });
            });
            document.addEventListener('keyup', (e) => {
                if (e.key === 'Escape') {
                    _this.evLayerClose();
                }
            });
            document.body.insertAdjacentElement('beforeend', this.layer);
        }
        return LayerAction._instance;
    }

    evLayerClose() {
        this.layer.classList.add('hidden');
        this.layerBody.innerHTML = '';
    }

    /**
     * trigger evRwSave
     */
    async evSaveData() {
        const _this = this;
        let fields = _this.layer.querySelectorAll('input, div.ckedit, select');
        let postData: IDictionary = {};
        fields.forEach((el: HTMLElement) => {
            if (el.hasAttribute('data-property')) {

                if (el.tagName === 'INPUT') {
                    let elInput = <HTMLInputElement>el;
                    if (elInput.type === 'file') {
                        postData[el.dataset.property] = <HTMLInputElement>el;
                    } else {

                        if (
                            (elInput.type === 'checkbox' && elInput.checked) ||
                            (elInput.type === 'radio' && elInput.checked)
                        ) {

                            if (el.dataset.property.match('\\[\\]')) {
                                let propName = el.dataset.property.replace('[]', '');
                                if (!postData[propName]) {
                                    postData[propName] = [];
                                }
                                postData[propName].push(elInput.value);
                            } else {
                                postData[el.dataset.property] = elInput.value;
                            }
                        } else {
                            postData[el.dataset.property] = elInput.value;
                        }
                    }
                }
                if (el.tagName === 'SELECT') {
                    // multiple?
                    const selectEl = <HTMLSelectElement>el;
                    if (selectEl.multiple) {
                        let selectedValue = [];
                        for (let i = 0; i < selectEl.options.length; i++) {
                            if (selectEl.options[i].selected) {
                                if (tools.isJson(selectEl.options[i].value)) {
                                    selectedValue.push(JSON.parse(selectEl.options[i].value));
                                } else {
                                    selectedValue.push(selectEl.options[i].value);
                                }
                            }
                        }
                        postData[selectEl.dataset.property] = JSON.stringify(selectedValue);
                    } else {
                        postData[selectEl.dataset.property] = selectEl.value;
                    }
                }
                if (el.tagName === 'DIV') {
                    let editor = CKEDITOR.instances[el.id];
                    postData[el.dataset.property] = editor.getData();
                }
            }
        });
        // TODO: route abhängig vom formular
        let rId = '';
        if (_this.actionButton.dataset.rw) {
            rId = '&rid=' + _this.actionButton.dataset.rw;
        }
        const data = await tools.fetchPOST(
            routes[_this.actionButton.dataset.cmd] + _this.actionButton.dataset.rwAction + rId,
            postData
        );
        // savestart
        let ev = new CustomEvent('evRwSave', { detail: data });
        window.dispatchEvent(ev);
    }

    /**
     *
     * @param actionEl
     * @param callCheck function call before open form, return false to cancel open
     * @returns
     */
    public static async open(actionEl: HTMLElement, callCheck: (el: HTMLElement) => {} = null) {
        const _this = LayerAction.Instance;
        _this.actionButton = actionEl;
        if (callCheck !== null) {
            const cb = await callCheck(actionEl);
            if (!cb) {
                return;
            }
        }
        let rId = '';
        if (actionEl.dataset.rw) {
            rId = '&rid=' + actionEl.dataset.rw;
        }
        let layerInner = await tools.fetchTEXT(
            routes[_this.actionButton.dataset.fetch] + actionEl.dataset.rwAction + rId
        );
        _this.layerBody.innerHTML = layerInner;
        _this.layerBody
            .querySelectorAll('input.rw-datetime-now')
            .forEach((el: HTMLInputElement) => {
                tools.setDateTimeInputNow(el);
            });
        _this.layerBody
            .querySelectorAll('input.rw-datetime-future')
            .forEach((el: HTMLInputElement) => {
                let dtInterval: string = el.dataset.future;
                let future = tools.setFuture(dtInterval);
                tools.setDateTimeInputNow(el, future);
            });
        _this.layerBody.querySelectorAll('.ckedit').forEach((el: HTMLElement) => {
            if (!window.CKEDITOR.instances[el.id]) {
                window.CKEDITOR.inline(el.id);
            }
        });
        _this.layerBody
            .querySelectorAll('select.ac-select')
            .forEach((selectEl: HTMLSelectElement) => {
                let acData: Array<components.IAutoCompleteItem> = [];
                for (let i = 0; i < selectEl.options.length; i++) {
                    let acItem: components.IAutoCompleteItem = {
                        id: 'item-' + i,
                        label: selectEl.options[i].innerText,
                        data: selectEl.options[i].value,
                        index: i,
                        selected: selectEl.options[i].selected
                    };
                    acData.push(acItem);
                }
                let acSelectField = document.createElement('input');
                acSelectField.id = 'browserfix-' + new Date().getTime();
                acSelectField.autocomplete = 'chrome-off';
                acSelectField.type = 'text';
                selectEl.insertAdjacentElement('afterend', acSelectField);
                let acHiddenField = document.createElement('input');
                acHiddenField.type = 'hidden';
                acHiddenField.classList.add('ac-hidden-field');
                acHiddenField.dataset.property = selectEl.dataset.property;
                selectEl.removeAttribute('data-property');
                acHiddenField.name = selectEl.name;
                selectEl.insertAdjacentElement('afterend', acHiddenField);
                selectEl.classList.add('d-none');
                let ac = new components.Autocomplete({
                    owner: acSelectField,
                    items: acData,
                    valueField: <HTMLInputElement>acHiddenField,
                    autoOpen: true,
                    fontello: {
                        prefix: 'icon',
                        opener: 'icon-down-open-big'
                    },
                    onSelect: (item) => {
                        acHiddenField.value = item.data;
                        selectEl.selectedIndex = item.index;
                    }
                });
                // selectEl
            });
        new components.TrafficSelector(_this.layerBody);
        new components.Tabs(_this.layerBody);
        // prefill ckedit
        _this.layer.querySelectorAll('.ckedit').forEach(async (editor: HTMLElement) => {
            if (editor.dataset.preFill) {
                const preFillUrl = routes.RWIso2Utf + editor.dataset.preFill;
                // '/?ajax=RWDefault&action=iso2utf&url=' + editor.dataset.preFill;
                let ajaxHtml = await tools.fetchTEXT(preFillUrl);
                const domparser = new DOMParser();
                const doc = domparser.parseFromString(ajaxHtml, 'text/html');
                let cleanHtml = doc.body.innerHTML;
                // PRE to DIV
                cleanHtml = cleanHtml.replace(/(\<\/?)pre[^\>]*/g, '$1div');
                // remove inline styles
                cleanHtml = cleanHtml.replace(/\s?style=("|')[^\1]*\1/g, '');
                editor.innerHTML = cleanHtml;
            }
        });
        new Hvd.CKEditor(_this.layer);
        _this.layer.classList.remove('hidden');
    }
    public static close() {
        const _this = LayerAction.Instance;
        _this.evLayerClose();
    }
}
